"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7347,9518,1412],{

/***/ 11745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62414);
/* harmony import */ var src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37398);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






const FilterTag = _ref => {
  let {
    item,
    groupKey,
    hasCloseButton,
    onClick
  } = _ref;
  const isHidden = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_3__/* .filterIsHidden */ .ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_3__/* .filterIsSelected */ .$W)(item, groupKey));
  const label = hasCloseButton && item.label && item.label !== '' ? item.label : item.name;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    isSelected: isSelected,
    onClick: onClick,
    hasCloseButton: hasCloseButton,
    label: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTag);

/***/ }),

/***/ 94974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NltOffers_FiltersList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/redux/nlt-offer/actions.ts
var actions = __webpack_require__(26869);
// EXTERNAL MODULE: ./src/themes/index.tsx + 3 modules
var themes = __webpack_require__(75159);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListBox.tsx





const FiltersListBox = _ref => {
  let {
    display,
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    borderRadius: {
      base: 0,
      md: 10
    },
    bg: "baseWhite",
    p: "l",
    mt: "xxs",
    borderWidth: {
      base: 0,
      md: 1
    },
    borderColor: themes/* theme.colors.borders.grey */.r.colors.borders.grey,
    boxShadow: themes/* theme.shadows.cards */.r.shadows.cards,
    textAlign: "left",
    display: display,
    whiteSpace: {
      base: 'nowrap',
      md: 'normal'
    },
    children: children
  });
};

/* harmony default export */ var NltOffers_FiltersListBox = (FiltersListBox);
// EXTERNAL MODULE: ./src/components/NltOffers/FilterTag.tsx
var FilterTag = __webpack_require__(11745);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 1 modules
var accordion_dist_index_esm = __webpack_require__(27190);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListItemsWrapper.tsx




const FiltersListItemsWrapper = _ref => {
  let {
    items,
    isMobile,
    listedRows,
    children
  } = _ref;

  if (items.some(item => item.icon !== undefined) && !isMobile) {
    return listedRows ? /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
      minChildWidth: "100%",
      spacing: "8px",
      children: children
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
      minChildWidth: "5.625rem",
      spacing: "8px",
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    overflowX: {
      base: 'scroll',
      md: null
    },
    paddingBottom: {
      base: '0.5rem',
      md: null
    },
    children: children
  });
};

/* harmony default export */ var NltOffers_FiltersListItemsWrapper = (FiltersListItemsWrapper);
// EXTERNAL MODULE: ./src/components/common/Offers/FilterTagImage.tsx
var FilterTagImage = __webpack_require__(17679);
// EXTERNAL MODULE: ./src/redux/nlt-offer/selectors.ts
var selectors = __webpack_require__(37398);
;// CONCATENATED MODULE: ./src/components/NltOffers/FilterTagImage.tsx






const FilterTagImage_FilterTagImage = _ref => {
  let {
    item,
    groupKey,
    onClick,
    isMobile
  } = _ref;
  const isHidden = (0,es/* useSelector */.v9)((0,selectors/* filterIsHidden */.ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)(item, groupKey));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTagImage/* default */.Z, {
    isSelected: isSelected,
    label: item.name,
    icon: item.icon,
    isMobile: isMobile,
    onClick: onClick
  });
};

/* harmony default export */ var NltOffers_FilterTagImage = (FilterTagImage_FilterTagImage);
// EXTERNAL MODULE: ./src/components/common/Offers/FilterTagCheckbox.tsx
var FilterTagCheckbox = __webpack_require__(96406);
;// CONCATENATED MODULE: ./src/components/NltOffers/FilterTagCheckbox.tsx






const FilterTagCheckbox_FilterTagCheckbox = _ref => {
  let {
    item,
    groupKey,
    onClick
  } = _ref;
  const isHidden = (0,es/* useSelector */.v9)((0,selectors/* filterIsHidden */.ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)(item, groupKey));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTagCheckbox/* default */.Z, {
    isChecked: isSelected,
    onChange: onClick,
    label: item.name
  });
};

/* harmony default export */ var NltOffers_FilterTagCheckbox = (FilterTagCheckbox_FilterTagCheckbox);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListItemContent.tsx








const FiltersListItemContent = _ref => {
  let {
    filter
  } = _ref;
  const dispatch = (0,es/* useDispatch */.I0)();
  const isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });

  const toggleFilterHandler = (filter, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
    borderBottomWidth: {
      base: '0 !important'
    },
    borderTopWidth: {
      base: '0',
      md: '1px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
      paddingInlineStart: "0",
      paddingInlineEnd: "0",
      py: 4,
      _hover: {
        background: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        flex: "1",
        textAlign: "left",
        textTransform: "uppercase",
        fontFamily: "Montserrat-SemiBold",
        children: filter.label
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
      paddingInlineStart: "0",
      paddingInlineEnd: "0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemsWrapper, {
        items: filter.items,
        isMobile: isMobile,
        listedRows: filter.type === 'check',
        children: filter.type === 'icon' ? filter.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FilterTagImage, {
          isMobile: isMobile,
          item: item,
          groupKey: filter.key,
          onClick: () => toggleFilterHandler(item, filter.key)
        }, `filters-brands-${item.name}-${item.value}`)) : filter.type === 'check' && !isMobile ? filter.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FilterTagCheckbox, {
          item: item,
          groupKey: filter.key,
          onClick: () => toggleFilterHandler(item, filter.key)
        }, `filters-${item.name}-${item.value}`)) : filter.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTag/* default */.Z, {
          item: item,
          groupKey: filter.key,
          onClick: () => toggleFilterHandler(item, filter.key)
        }, `filters-${item.name}-${item.value}`))
      })
    })]
  });
};

/* harmony default export */ var NltOffers_FiltersListItemContent = (FiltersListItemContent);
// EXTERNAL MODULE: ./src/components/common/Offers/FilterSwitch.tsx
var FilterSwitch = __webpack_require__(50178);
;// CONCATENATED MODULE: ./src/components/NltOffers/FilterSwitch.tsx






const FilterSwitch_FilterSwitch = _ref => {
  let {
    groupKey,
    title,
    label,
    onChange
  } = _ref;
  const isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)({
    label,
    name: title,
    value: '1'
  }, groupKey));
  const {
    0: checked,
    1: setChecked
  } = (0,react.useState)(isSelected);
  (0,react.useEffect)(() => {
    return setChecked(isSelected);
  }, [isSelected]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterSwitch/* default */.Z, {
    label: label,
    title: title,
    isSelected: checked,
    onChange: onChange
  });
};

/* harmony default export */ var NltOffers_FilterSwitch = (FilterSwitch_FilterSwitch);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListItemNoChildren.tsx









const FiltersListItemNoChildren = _ref => {
  let {
    items,
    groupKey
  } = _ref;
  const dispatch = (0,es/* useDispatch */.I0)();

  const toggleFilterHandler = (filter, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      display: {
        base: 'block',
        md: 'none'
      },
      children: "Tag"
    }), items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTag/* default */.Z, {
      item: item,
      groupKey: groupKey,
      onClick: () => toggleFilterHandler(item, groupKey)
    }, `filters-ref-${item.name}-${item.value}`))]
  });
};

/* harmony default export */ var NltOffers_FiltersListItemNoChildren = (FiltersListItemNoChildren);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListItem.tsx





const FiltersListItem = _ref => {
  let {
    items
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
    fontFamily: "Montserrat-Regular",
    allowToggle: true,
    children: Object.keys(items).map(idx => /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemContent, {
      filter: items[idx]
    }, idx))
  });
};

/* harmony default export */ var NltOffers_FiltersListItem = (FiltersListItem);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListGroup.tsx










const FiltersListGroup = _ref => {
  let {
    groupLabel,
    group
  } = _ref;
  const dispatch = (0,es/* useDispatch */.I0)();
  const isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });

  const toggleFilterHandler = (value, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(value, groupKey));

  return isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: group.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
      fontFamily: "Montserrat-Regular",
      allowToggle: true,
      defaultIndex: [0],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemContent, {
          filter: group[0]
        })
      })
    }) : group.map(filter => /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
      fontFamily: "Montserrat-Regular",
      allowToggle: true,
      defaultIndex: [0],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemContent, {
          filter: filter
        })
      })
    }, filter.label))
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListBox, {
    children: group.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: group[0].type === 'switch' ? /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FilterSwitch, {
        groupKey: group[0].key,
        title: group[0].group,
        label: group[0].label,
        onChange: _ref2 => {
          let {
            target
          } = _ref2;
          return toggleFilterHandler(target.value, group[0].key);
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
          as: "h4",
          fontFamily: "Montserrat-SemiBold",
          fontSize: themes/* theme.space.m */.r.space.m,
          color: "baseNeutral.700",
          pb: 4,
          children: groupLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemNoChildren, {
          items: group[0].items,
          groupKey: group[0].key
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        as: "h4",
        fontFamily: "Montserrat-SemiBold",
        fontSize: themes/* theme.space.m */.r.space.m,
        color: "baseNeutral.700",
        pb: 4,
        children: groupLabel
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItem, {
        items: group
      })]
    })
  });
};

/* harmony default export */ var NltOffers_FiltersListGroup = (FiltersListGroup);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListGroups.tsx






const FiltersListGroups = () => {
  const filters = (0,es/* useSelector */.v9)(state => state.nlt.filters);
  const filtersGrouped = filters.reduce((r, a) => {
    r[a.group] = r[a.group] || [];
    r[a.group].push(a);
    return r;
  }, Object.create(null));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: Object.keys(filtersGrouped).map(filterGroup => /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListGroup, {
      groupLabel: filterGroup,
      group: filtersGrouped[filterGroup]
    }, filterGroup))
  });
};

/* harmony default export */ var NltOffers_FiltersListGroups = (FiltersListGroups);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersList.tsx











const FiltersList = () => {
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const dispatch = (0,es/* useDispatch */.I0)();

  const toggleFilterHandler = (filter, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));

  const suggestedFilters = (0,es/* useSelector */.v9)(state => state.nlt.suggestedFilters);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(NltOffers_FiltersListBox, {
      display: {
        base: 'block',
        md: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontFamily: "Montserrat-SemiBold",
        fontWeight: "bold",
        fontSize: themes/* theme.space.s */.r.space.s,
        color: "baseNeutral.700",
        pb: "4",
        children: t('offersListContainer:suggestedFilters')
      }), suggestedFilters.map(filterGroup => filterGroup.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTag/* default */.Z, {
        item: item,
        groupKey: filterGroup.key,
        onClick: () => toggleFilterHandler(item, filterGroup.key)
      }, `suggested-${item.name}-${item.value}`)))]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListGroups, {})]
  });
};

/* harmony default export */ var NltOffers_FiltersList = (FiltersList);

/***/ }),

/***/ 57347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NltOffers_MobileActionBar; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/uikit/Sticky/index.tsx
var Sticky = __webpack_require__(26432);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 1 modules
var modal_dist_index_esm = __webpack_require__(83292);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./src/redux/nlt-offer/actions.ts
var actions = __webpack_require__(26869);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NltOffers/SortsModal.tsx










const SortsModal = () => {
  const dispatch = (0,es/* useDispatch */.I0)();
  const {
    isOpen,
    onOpen,
    onClose
  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
  const orders = (0,es/* useSelector */.v9)(state => state.nlt.orders);
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();

  const changeOrderHandler = value => dispatch((0,actions/* toggleOrder */.YQ)(value));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
      w: "100%",
      h: "14",
      as: "button",
      onClick: onOpen,
      children: [t('nltActionbarContainer:sortBy'), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ChevronDownIcon */.v4, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* Drawer */.dy, {
      placement: "bottom",
      onClose: onClose,
      isOpen: isOpen,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerOverlay */.P1, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* DrawerContent */.sc, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerCloseButton */.cC, {
          mt: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerHeader */.OX, {
          borderBottomWidth: "1px",
          children: t('nltMobileFiltersModalContainer:doSort')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerBody */.Ng, {
          children: orders.map(sort => /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
            borderRadius: "0",
            w: "100%",
            bg: "baseWhite",
            mt: "xxs",
            onClick: () => changeOrderHandler(sort.value),
            fontWeight: "normal",
            children: sort.label || sort.name
          }, sort.value))
        })]
      })]
    })]
  });
};

/* harmony default export */ var NltOffers_SortsModal = (SortsModal);
// EXTERNAL MODULE: ./src/icons/filters.tsx
var filters = __webpack_require__(11101);
// EXTERNAL MODULE: ./src/components/NltOffers/FiltersList.tsx + 10 modules
var FiltersList = __webpack_require__(94974);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersModal.tsx











const FiltersModal = () => {
  const dispatch = (0,es/* useDispatch */.I0)();
  const {
    isOpen,
    onOpen,
    onClose
  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const offers = (0,es/* useSelector */.v9)(state => state.nlt.filteredOffers);
  const selectedFilters = (0,es/* useSelector */.v9)(state => state.nlt.selectedFilters);
  let selectedFiltersCount = 0;
  (0,react.useEffect)(() => {
    selectedFiltersCount = selectedFilters.reduce((prev, current) => prev + current.items.length, 0);
  }, []);

  const resetFiltersHandler = () => {
    dispatch((0,actions/* resetAllFilters */._4)());
    onClose();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
      w: "100%",
      h: "14",
      bg: "primaryGreen.300",
      as: "button",
      onClick: onOpen,
      children: [selectedFiltersCount > 0 ? t('nltActionbarContainer:filters', {
        count: selectedFiltersCount
      }) : t('nltActionbarContainer:showFilters'), /*#__PURE__*/(0,jsx_runtime.jsx)(filters/* default */.Z, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* Modal */.u_, {
      onClose: onClose,
      size: "full",
      isOpen: isOpen,
      scrollBehavior: "inside",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
          textAlign: "center",
          children: t('nltMobileFiltersModalContainer:doFilter')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {
          mt: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
          p: "0",
          bg: "baseNeutral.200",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FiltersList/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalFooter */.mz, {
          display: "block",
          padding: "0",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Wrap */.Eq, {
            spacing: "0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
              w: "50%",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                w: "100%",
                h: "14",
                borderColor: "primaryGreen.300",
                color: "primaryGreen.900",
                variant: "outline",
                borderRadius: "0",
                onClick: resetFiltersHandler,
                children: t('nltMobileFiltersModalContainer:resetFilters')
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
              w: "50%",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                w: "100%",
                h: "14",
                bg: "primaryGreen.300",
                as: "button",
                onClick: onClose,
                children: t('nltMobileFiltersModalContainer:showFoundOffer', {
                  value: offers.results
                })
              })
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var NltOffers_FiltersModal = (FiltersModal);
;// CONCATENATED MODULE: ./src/components/NltOffers/MobileActionBar.tsx







const MobileActionBar = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Sticky/* default */.Z, {
    h: "14",
    visible: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Wrap */.Eq, {
      spacing: "0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
        w: "50%",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_SortsModal, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
        w: "50%",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersModal, {})
      })]
    })
  });
};

/* harmony default export */ var NltOffers_MobileActionBar = (MobileActionBar);

/***/ }),

/***/ 50178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68185);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const FilterSwitch = _ref => {
  let {
    title,
    label,
    isSelected,
    onChange
  } = _ref;
  const {
    0: checked,
    1: setChecked
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isSelected);
  const {
    0: isMounted,
    1: setMount
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setChecked(isSelected);
  }, [isSelected]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const onSwitchChange = evt => {
    const {
      target: {
        value
      }
    } = evt;
    setChecked(value === '1');
    onChange(evt);
    return value === '1';
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
      as: "span",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.875rem",
      color: "#656b72",
      children: label
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Switch */ .r, {
      colorScheme: "green",
      isChecked: checked,
      float: "right",
      value: "1",
      onChange: onSwitchChange
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterSwitch);

/***/ }),

/***/ 62414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3382);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const FilterTag = _ref => {
  let {
    isSelected,
    hasCloseButton,
    label,
    onClick
  } = _ref;
  const {
    0: isMounted,
    1: setMount
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const bgColor = isSelected ? src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[300] */ .r.colors.primaryGreen[300] : 'white';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    color: src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[900] */ .r.colors.primaryGreen[900],
    variant: "outline",
    fontFamily: "Montserrat-Medium",
    fontWeight: "normal",
    size: "xs",
    h: "32px",
    mr: 1,
    my: 1,
    borderRadius: 4,
    bg: bgColor,
    _hover: {
      backgroundColor: bgColor
    },
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[300] */ .r.colors.primaryGreen[300],
    userSelect: "none",
    onClick: onClick,
    rightIcon: hasCloseButton ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_4__/* .CloseIcon */ .Tw, {
      boxSize: "0.7rem"
    }) : undefined,
    children: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTag);

/***/ }),

/***/ 96406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9135);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





const FilterTagCheckbox = _ref => {
  let {
    isChecked,
    label,
    onChange
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Checkbox */ .XZ, {
    fontFamily: "Montserrat-Medium",
    color: "baseDark",
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.primaryGreen[900] */ .r.colors.primaryGreen[900],
    colorScheme: "primaryGreenCheckboxFilter",
    isChecked: isChecked,
    display: "block",
    size: "lg",
    lineHeight: "1.2",
    mb: "s",
    className: "filterCheck",
    onChange: onChange,
    children: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTagCheckbox);

/***/ }),

/***/ 17679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75159);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const FilterTagImage = _ref => {
  let {
    isSelected,
    label,
    icon,
    onClick,
    isMobile
  } = _ref;
  const borderColor = isSelected ? `${src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.green[600] */ .r.colors.green[600]}, 0 2px 8px 0 rgba(44, 190, 97, 0.13)` : src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.borders.grey */ .r.colors.borders.grey;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Badge */ .Ct, {
    suppressHydrationWarning: true,
    as: "button",
    variant: "outline",
    p: 2,
    m: 1,
    h: isMobile ? '4.563rem' : '4.688rem',
    w: isMobile ? '5.625rem' : '',
    borderRadius: 4,
    textTransform: "none",
    boxShadow: `inset 0 0 0px 1px ${borderColor}`,
    color: "baseNeutral.700",
    onClick: onClick,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
      src: icon,
      alt: "",
      width: "40",
      height: "40"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      children: label
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTagImage);

/***/ }),

/***/ 11101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const FiltersIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#1B4832",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M8.25 11.25c.98 0 1.814.626 2.122 1.5H16.1c.22 0 .4.18.4.4v.7c0 .22-.18.4-.4.4h-5.728c-.31.874-1.142 1.5-2.122 1.5s-1.813-.626-2.122-1.5H1.9c-.22 0-.4-.18-.4-.4v-.7c0-.22.18-.4.4-.4h4.228c.308-.874 1.142-1.5 2.122-1.5zm0 1.2c-.58 0-1.05.47-1.05 1.05 0 .58.47 1.05 1.05 1.05.58 0 1.05-.47 1.05-1.05 0-.58-.47-1.05-1.05-1.05zm4.5-5.7c.98 0 1.814.626 2.122 1.5H16.1c.22 0 .4.18.4.4v.7c0 .22-.18.4-.4.4h-1.228c-.31.874-1.142 1.5-2.122 1.5s-1.813-.626-2.122-1.5H1.9c-.22 0-.4-.18-.4-.4v-.7c0-.22.18-.4.4-.4h8.728c.308-.874 1.142-1.5 2.122-1.5zm0 1.2c-.58 0-1.05.47-1.05 1.05 0 .58.47 1.05 1.05 1.05.58 0 1.05-.47 1.05-1.05 0-.58-.47-1.05-1.05-1.05zM6 2.25c.98 0 1.814.626 2.122 1.5H16.1c.22 0 .4.18.4.4v.7c0 .22-.18.4-.4.4H8.122c-.31.874-1.142 1.5-2.122 1.5s-1.813-.626-2.122-1.5H1.9c-.22 0-.4-.18-.4-.4v-.7c0-.22.18-.4.4-.4h1.978C4.186 2.877 5.02 2.25 6 2.25zm0 1.2c-.58 0-1.05.47-1.05 1.05 0 .58.47 1.05 1.05 1.05.58 0 1.05-.47 1.05-1.05 0-.58-.47-1.05-1.05-1.05z",
        transform: "translate(-318 -1991) translate(0 1972) translate(187) translate(131 19)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (FiltersIcon);

/***/ }),

/***/ 26432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71197);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["visible", "children", "height", "h"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const Sticky = _ref => {
  let {
    visible,
    children,
    height,
    h
  } = _ref,
      other = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Slide */ .Mi, {
    direction: "bottom",
    style: {
      zIndex: 2
    },
    in: visible,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, _objectSpread(_objectSpread({
      bg: "baseWhite",
      boxShadow: "0 -2px 10px 0px rgba(0, 0, 0, 0.08)",
      h: height || h
    }, other), {}, {
      children: children
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Sticky);

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);